<template>
  <app-card
    class="p-6 flex flex-col"
    :status="contract.signed_at ? 'complete' : 'incomplete'"
  >
    <div>
      <app-badge
        v-if="contract.signed_at"
        type="positive"
        icon="check"
      >
        Signed
      </app-badge>
      <app-badge
        v-else
        type="neutral"
        icon="important"
      >
        Unsigned
      </app-badge>
      <h2 class="text-lg">
        {{ partner.company.name }}
      </h2>
      <p>{{ contract.title }}</p>
      <p><small>Version: {{ contract.revision }}</small></p>
    </div>
    <div
      
      class="text-grey-700 mt-auto text-sm mt-2 mb-6"
    >
      <template v-if="contract.signed_at">
        <p><b>Signatory:</b> {{ signed_by }}</p>
        <p><b>Date:</b> {{ signed_at }}</p>
      </template>
    </div>
    <div class="border-t pt-4 flex items-center">
      <icon-link
        href="#"
        icon="search"
        target="_blank"
        @click.prevent="contractModal = true"
      >
        Preview
      </icon-link>
      <icon-link
        v-if="contract.signed_at"
        :href="route('applications.files.download-project-file-from-path', { application: uuid, file: contract.file })"
        class="ml-auto"
        icon="cheveron-down-circle"
        icon-placement="right"
        target="_blank"
      >
        Signed Contract
      </icon-link>
    </div>
    <portal to="modals">
      <app-modal
        v-if="contractModal"
        class="text-center"
        @close="contractModal = false"
      >
        <app-card class="mx-4 text-left content p-12 is-borderless">
          <div
            v-for="(section, index) in contract.sections"
            :key="index"
            class="max-w-lg"
          >
            <h2 class="mb-4">
              {{ section.heading }}
            </h2>
            <div v-html="parseMarkdown(section.content)" />
          </div>
        </app-card>
        <button 
          class="text-negative-600 px-6 py-4 mt-2 font-bold focus:outline-none hover:underline text-sm"
          @click="contractModal = false"
        >
          Close
        </button>
      </app-modal>
    </portal>
  </app-card>
</template>

<script>
import { format, parseISO } from 'date-fns'
export default {
  name: 'FundingProjectContractCard',
  props: {
    partner: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      contractModal: false
    }
  },
  computed: {
    uuid() {
      return window._project
    },
    signed_by() {
      const user = this.partner.users.find(user => user.user_id === this.contract.signed_by)
      if(!user) return false;
      return user.user.name
    },
    signed_at() {
      if(!this.contract.signed_at) return false;
      return format(parseISO(this.contract.signed_at), 'do MMMM yyyy HH:mm')
    },
    contract() {
      return this.partner.latest_contract
    }
  }
}
</script>